// extracted by mini-css-extract-plugin
export var hidden = "ProfileMenuBarDropdown-module--hidden--c0b19";
export var menuIcon = "ProfileMenuBarDropdown-module--menu-icon--eab86";
export var navDivider = "ProfileMenuBarDropdown-module--nav-divider--c03c6";
export var profileMenuBarDropdownContainer = "ProfileMenuBarDropdown-module--profile-menu-bar-dropdown-container--0515b";
export var profileMenuLink = "ProfileMenuBarDropdown-module--profile-menu-link--51f6d";
export var singleMenuItem = "ProfileMenuBarDropdown-module--single-menu-item--0f45e";